module.exports = __webpack_public_path__ + "static/media/iphone 11.6ac56614.jpg";